module.exports = __webpack_public_path__ + "static/media/upload.fa1eca41.svg";